module.exports = __webpack_public_path__ + "img/bg_line_newspaper.b9913021.jpg";